import { useState, useEffect } from 'react'

export function useScrollSpy(ids, offset = 100) {
  const [activeId, setActiveId] = useState('')

  useEffect(() => {
    const listener = () => {
      const scroll = window.pageYOffset

      const position = ids
        .map((id) => {
          const element = document.getElementById(id)
          if (!element) return { id, top: -1 }
          const rect = element.getBoundingClientRect()
          const top = rect.top + scroll
          return { id, top }
        })
        .filter(({ top }) => top < scroll + offset)

      const last = position[position.length - 1]
      setActiveId(last?.id || '')
    }

    listener()
    window.addEventListener('scroll', listener)
    return () => {
      window.removeEventListener('scroll', listener)
    }
  }, [ids, offset])

  return activeId
}